export const SELECT_PRODUCTS = 'SELECT_PRODUCTS';
export const selectProducts = ids => ({
  type: SELECT_PRODUCTS,
  payload: ids
});
